import { render, staticRenderFns } from "./PageManage.vue?vue&type=template&id=ec62724e&"
import script from "./PageManage.vue?vue&type=script&lang=js&"
export * from "./PageManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports